import { organizationService } from '@organization/service/organizaion/organizationService';
import { store } from '@store';
import { Locale } from 'chaika-enums';
import { useEffect } from 'react';

interface Data {
    getPracticeName(id: string): string;
}

export function usePractice(): Data {
    const { practiceList } = store.organizationList;
    const { selectedLanguage } = store.authUser;
    useEffect(() => {
        (async () => {
            await organizationService.loadPractices();
        })();
    }, []);

    function getPracticeName(id: string): string {
        const practice = practiceList.get(id);

        if (!practice) {
            return id;
        }

        const notRusLocal = selectedLanguage !== Locale.Ru;
        const ruName = practice.nameRu ?? practice.practice ?? id;

        return notRusLocal ? (practice.nameEn ?? practice.nameEnShort ?? ruName) : ruName;
    }

    return {
        getPracticeName,
    };
}
